import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CardDiv from "modules/common/card-div/CardDiv";
import SoftBadge from "modules/common/SoftBadge";
import { Image } from "antd";
import { useTagsStore } from "./store";
import NoData from "assets/svgs/no_data/NoData";
import { fourPlaceHolder } from "modules/utilities/utility";
import { useNavigate } from "react-router-dom";


function TagDetail() {
  const { tagId, tagMasterName } = useParams();
  const { tagComponentData, tagComponentLoading, fetchTagComponent } =
    useTagsStore();
  const navigate=useNavigate();

  useEffect(() => {
    if (tagId) {
      fetchTagComponent(tagId);
    }
  }, [tagId]);

 const handleBack=()=>{
  navigate("/manage-tags");
 }

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex gap-3">
            <button className="btn btn-primary" onClick={handleBack}>Back</button>
            <div className="fs-2">{tagMasterName}</div>
          </div>
        }
        component={
          <div
            className="scrollable-container"
            style={{
              maxHeight: "80vh",
              top: 20,
              position: "sticky",
              top: "0",
              overflowY: "scroll",
            }}
          >
            <div className="row gap-3 p-2">
              {tagComponentLoading ? (
                fourPlaceHolder()
              ) : tagComponentData?.data?.result?.length ? (
                <Image.PreviewGroup>
                  {tagComponentData?.data?.result?.map((image, index) => (
                    <div
                      className="border col-sm-3 card p-3 scrollable-container"
                      style={{ width: "38vh" }}
                    >
                      <div>
                        <Image
                          className="bg-secondary rounded text-center"
                          src={image.standardAttributes.backgroundImage}
                          style={{ width: "18vw", height: "30rem" }}
                        />
                      </div>
                      <div className="mt-2">
                        <span className="fw-bold"> Subject:</span>
                        {image?.standardAttributes?.subject}
                      </div>
                      <div className="mt-2">
                        <span className="fw-bold"> Sub Text: </span>
                        {image?.standardAttributes?.subText}
                      </div>
                      <div className="mt-2">
                        <span className="fw-bold"> Content Link: </span>
                        {image?.componentAttributes?.contentLink}
                      </div>
                      <div className="mt-2">
                        <span className="fw-bold"> Display Name: </span>
                        {image?.displayName}
                      </div>
                      <div className="mt-2">
                        <span className="fw-bold"> Type: </span>
                        {image?.type}
                      </div>
                      <div className="mt-2">
                        <span className="fw-bold"> Is Active: </span>
                        {image?.isActive}
                      </div>
                      <div className="mt-2">
                        <span className="fw-bold">
                          Background Image Link:
                        </span>
                        <a
                          href={image.standardAttributes.backgroundImage}
                          target="blank"
                        >
                          Image Url
                        </a>
                      </div>
                    </div>
                  ))}
                </Image.PreviewGroup>
              ) : (
                <div className="fs-1 text-center">
                  Data not found <NoData />
                </div>
              )}
            </div>
          </div>
        }
      />
    </div>
  );
}

export default TagDetail;
